'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // 要素を選択
  const heroElement = document.querySelector('.js-hero') as HTMLElement;
  const fixFootElement = document.querySelector('.js-fixFoot') as HTMLElement;
  const frontHeroElement = document.querySelector(
    '.js-frontHero'
  ) as HTMLElement;
  const headerWrap = document.querySelectorAll(
    '.js-headerWrap'
  ) as NodeListOf<HTMLElement>;

  // IntersectionObserverの設定
  const options: IntersectionObserverInit = {
    root: null, // ビューポートをルートとして使用
    threshold: 0, // ヒーロー要素がビューポートから完全に外れたときにコールバックをトリガー
  };

  // IntersectionObserverのコールバック
  // IntersectionObserverのコールバック
  const observerCallbackFront: IntersectionObserverCallback = (
    entries,
    observer
  ) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        // ヒーロー要素がビューポートから外れたときに各headerWrap要素に 'is-active' クラスを追加
        headerWrap.forEach((element) => {
          element.classList.add('is-active');
        });
      } else {
        // ヒーロー要素がビューポート内にあるときに各headerWrap要素から 'is-active' クラスを削除
        headerWrap.forEach((element) => {
          element.classList.remove('is-active');
        });
      }
    });
  };

  // IntersectionObserverのコールバック
  const observerCallback: IntersectionObserverCallback = (
    entries,
    observer
  ) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        // ヒーロー要素がビューポートから外れたときにCTA要素に 'is-active' クラスを追加
        fixFootElement.classList.add('is-active');
      } else {
        // ヒーロー要素がビューポート内にあるときにCTA要素から 'is-active' クラスを削除
        fixFootElement.classList.remove('is-active');
      }
    });
  };

  // IntersectionObserverのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, options);

  // IntersectionObserverのインスタンスを作成(Front)
  const observerFront = new IntersectionObserver(
    observerCallbackFront,
    options
  );

  // ヒーロー要素を監視
  observer.observe(heroElement);

  // frontHeroElementが存在する場合、それも監視対象に追加
  if (frontHeroElement) {
    observerFront.observe(frontHeroElement);
  }
});
